/**
 * @file reducers/Video/reducer.js
 * @copyright 2020 CBC/Radio-Canada. All rights reserved.
 */

import extractCurrentClip, {
    initialState as currentClipInitState,
} from "./DataExtractors/CurrentClip";
import extractTrendingClips, {
    initialState as trendingClipsInitState,
} from "./DataExtractors/TrendingClips";
import extractCuratedPlaylist, {
    initialState as curatedPlaylistInitState,
} from "./DataExtractors/CuratedPlaylist";
import extractMoreFromBaseSection, {
    initialState as moreFromBaseSectionInitState,
} from "./DataExtractors/MoreFromBaseSection";

const initialVideoState = () => {
    return {
        currentClip: currentClipInitState,
        trendingClips: trendingClipsInitState,
        curatedPlaylist: curatedPlaylistInitState,
        moreFromBaseSection: moreFromBaseSectionInitState,
    };
};

export default function video(state, action) {
    if (!state) {
        state = initialVideoState();
    }

    return {
        currentClip: extractCurrentClip(action) || state.currentClip,
        trendingClips: extractTrendingClips(action) || state.trendingClips,
        curatedPlaylist:
            extractCuratedPlaylist(action) || state.curatedPlaylist,
        moreFromBaseSection:
            extractMoreFromBaseSection(action) || state.moreFromBaseSection,
    };
}
